import styled, { css } from 'styled-components';
import { colorUsage, getSpacing } from 'stylesheet';
import { Duplicate, Trash } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "RepeatedFieldstyle__Container",
  componentId: "sc-gifpl4-0"
})(["display:flex;width:100%;"]);
var FieldsContainer = styled.div.withConfig({
  displayName: "RepeatedFieldstyle__FieldsContainer",
  componentId: "sc-gifpl4-1"
})(["display:flex;width:inherit;margin-right:", ";"], getSpacing(2));
var CTAContainer = styled.div.withConfig({
  displayName: "RepeatedFieldstyle__CTAContainer",
  componentId: "sc-gifpl4-2"
})(["display:flex;flex-direction:column;justify-content:center;width:25px;& >:not(:first-child){margin-top:", ";}"], getSpacing(1));
var IconButton = styled.div.withConfig({
  displayName: "RepeatedFieldstyle__IconButton",
  componentId: "sc-gifpl4-3"
})(["line-height:initial;"]);
var iconProperties = css(["width:16px;height:16px;cursor:pointer;& path{fill:", ";}"], colorUsage.defaultIconColor);
var AppendIcon = styled(Duplicate).withConfig({
  displayName: "RepeatedFieldstyle__AppendIcon",
  componentId: "sc-gifpl4-4"
})(["", " &:hover path{fill:", ";}"], iconProperties, colorUsage.iconGradientHoverForeground);
var RemoveIcon = styled(Trash).withConfig({
  displayName: "RepeatedFieldstyle__RemoveIcon",
  componentId: "sc-gifpl4-5"
})(["", " &:hover path{fill:", ";}"], iconProperties, colorUsage.iconRemove);
export { FieldsContainer, CTAContainer, Container, AppendIcon, RemoveIcon, IconButton };